import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";
import { RoutesEnum } from "~/types/enums";
import logo from "~/assets/i/logo.svg";
import { Button, Card, Spinner, Text } from "~/components-shared";
import api from "~/lib/api";
import Footer from "~/components/Footer";
import CompleteSignUp from "~/components/CompleteSignUp";
import { useTranslation } from "react-i18next";
const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-size: contain;
`;
const Branding = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 5;
}}px;
`;
const Logo = styled.img`
  margin-right: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step;
}}px;
`;
const Content = styled.div`
  padding: 1em;
  display: flex;
  overflow-y: auto;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;
const VerifyEmail = () => {
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const {
    token
  } = qs.parse(search, {
    ignoreQueryPrefix: true
  });
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [data, setData] = useState(undefined);
  useEffect(() => {
    if (token) {
      setLoading(true);
      api.verifyInvitation(token).then(response => {
        setData(response);
      }).catch(e => {
        switch (e.response.status) {
          case 410:
            setError(t("VerifyEmail.invitationLinkExpired"));
            return;
          case 406:
            setError(t("VerifyEmail.invitationLinkCanceled"));
            return;
          case 403:
            setError(t("VerifyEmail.invitationLinkUsed"));
            return;
          default:
            history.replace(RoutesEnum.ROOT);
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [history, token]);
  if (!token) {
    history.replace(RoutesEnum.ROOT);
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      color: colors.primary.main,
      center: true
    });
  }
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Card, {
    maxWidth: "400px",
    s: {
      p: 10
    }
  }, /*#__PURE__*/React.createElement(Branding, null, /*#__PURE__*/React.createElement(Logo, {
    src: logo,
    alt: "Joyn",
    width: 40
  }), /*#__PURE__*/React.createElement("h2", null, "Joyn")), error ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    fontSize: 10,
    align: "center",
    s: {
      mb: 3
    }
  }, t("VerifyEmail.oops")), /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    fontSize: 7,
    align: "center",
    s: {
      mb: 3
    }
  }, error), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    s: {
      mt: 3
    },
    onClick: () => history.replace(RoutesEnum.ROOT),
    type: "submit",
    fullWidth: true
  }, t("VerifyEmail.gotoLoginPage"))) : data && /*#__PURE__*/React.createElement(CompleteSignUp, {
    data: data
  }))), /*#__PURE__*/React.createElement(Footer, null));
};
export default VerifyEmail;